import { Controller } from "@hotwired/stimulus"
import $ from "jquery"
import "datatables.net-dt"

export default class extends Controller {
  connect() {    
    this.table = $(this.element.querySelector("#results_table")).DataTable({
      paging: false,
      
      columnDefs: [ 
        // don't sort actions
        { orderable: false, targets: -1 } 
    ]
    })
    this.table = $(this.element.querySelector("#public_results_table")).DataTable({
      paging: false,
    })
    
  }

  disconnect() {
    if (this.table) {
      this.table.destroy()
    }
  }
}